// import React, { useState, useEffect } from "react";
// import styles from "../../assets/scss/TransportHandlers/TransportHandlersform.module.scss";
// import {
//   useCreateTempEmployeeMutation,
//   useUpdateTempEmployeeMutation
// } from "../../slices/admin/admin";
// import { toast } from "react-toastify";

// const AddTransportForm = ({ onClose, editData }) => {

//   const [createTempEmployee, { isLoading: createLoading }] =
//     useCreateTempEmployeeMutation();

//   const [updateTempEmployee, { isLoading: updateLoading }] =
//     useUpdateTempEmployeeMutation();

//   const [formData, setFormData] = useState({
//     userName: "",
//     phone: "",
//     userType: "",
//     status: ""
//   });

//   const [errors, setErrors] = useState({});

//   useEffect(() => {
//     if (editData) {
//       setFormData({
//         userName: editData.name || "",
//         phone: editData.phone || "",
//         userType: editData.empDesignation || "",
//         status: editData.isActive ? "true" : "false"
//       });
//     }
//   }, [editData]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//     setErrors({ ...errors, [name]: "" });
//   };

//   const validate = () => {
//     let newErrors = {};

//     if (!formData.userName.trim()) {
//       newErrors.userName = "User Name is required";
//     }

//     if (!formData.phone.trim()) {
//       newErrors.phone = "Phone Number is required";
//     } else if (!/^[0-9]{10}$/.test(formData.phone)) {
//       newErrors.phone = "Enter valid 10 digit phone number";
//     }

//     if (!formData.userType) {
//       newErrors.userType = "User Type is required";
//     }

//     if (!formData.status) {
//       newErrors.status = "User Status is required";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async () => {
//     if (!validate()) return;

//     const payload = {
//       name: formData.userName,
//       phone: formData.phone,
//       empDesignation: formData.userType,
//       isActive: formData.status === "true" // ✅ Correct boolean conversion
//     };

//     try {
//       if (editData) {
//         await updateTempEmployee({
//           id: editData._id,
//           body: payload
//         }).unwrap();

//         toast.success("Temporary Employee updated successfully");
//       } else {
//         await createTempEmployee(payload).unwrap();

//         toast.success("Temporary Employee created successfully");
//       }

//       onClose();

//     } catch (error) {
//       console.log("API Error:", error);

//       // ✅ Proper backend error message show
//       const errorMessage =
//         error?.data?.message ||
//         error?.data?.error ||
//         error?.error ||
//         "Something went wrong";

//       toast.error(errorMessage);
//     }
//   };

//   return (
//     <div className={styles.popupForm}>
//       <div className={styles.header}>
//         <h2 className={styles.tittle}>
//           {editData ? "Edit User" : "Add User"}
//         </h2>
//         <span className={styles.closeIcons} onClick={onClose}>X</span>
//       </div>

//       <div className={styles.body}>

//         <div className={styles.inputGroup}>
//           <label className={styles.inputLabel}>User Name *</label>
//           <input
//             type="text"
//             name="userName"
//             placeholder="Enter User Name"
//             value={formData.userName}
//             onChange={handleChange}
//             className={styles.input}
//           />
//           {errors.userName && (
//             <p style={{ color: "red", fontSize: "13px" }}>{errors.userName}</p>
//           )}
//         </div>

//         <div className={styles.inputGroup}>
//           <label className={styles.inputLabel}>Phone Num *</label>
//           <input
//             type="text"
//             name="phone"
//             placeholder="Enter Phone Num"
//             value={formData.phone}
//             onChange={handleChange}
//             className={styles.input}
//           />
//           {errors.phone && (
//             <p style={{ color: "red", fontSize: "13px" }}>{errors.phone}</p>
//           )}
//         </div>

//         <div className={styles.inputGroup}>
//           <label className={styles.inputLabel}>User Type *</label>
//           <select
//             name="userType"
//             value={formData.userType}
//             onChange={handleChange}
//             className={styles.inputssss}
//           >
//             <option value="">Select Type</option>
//             <option value="loadHandler">Load Handler</option>
//             <option value="transportPerson">Transport Person</option>
//           </select>
//           {errors.userType && (
//             <p style={{ color: "red", fontSize: "13px" }}>{errors.userType}</p>
//           )}
//         </div>

//         <div className={styles.inputGroup}>
//           <label className={styles.inputLabel}>User Status *</label>
//           <select
//             name="status"
//             value={formData.status}
//             onChange={handleChange}
//             className={styles.inputssss}
//           >
//             <option value="">Select Status</option>
//             <option value="true">Active</option>
//             <option value="false">Inactive</option>
//           </select>
//           {errors.status && (
//             <p style={{ color: "red", fontSize: "13px" }}>{errors.status}</p>
//           )}
//         </div>

//         <div className={styles.footerButtons}>
//           <button className={styles.cancel} onClick={onClose}>
//             Cancel
//           </button>

//           <button
//             className={styles.save}
//             onClick={handleSubmit}
//             disabled={createLoading || updateLoading}
//           >
//             {createLoading || updateLoading
//               ? "Please wait..."
//               : editData
//               ? "Update"
//               : "Add"}
//           </button>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default AddTransportForm;


import React, { useState, useEffect } from "react";
import styles from "../../assets/scss/TransportHandlers/TransportHandlersform.module.scss";
import {
  useCreateTempEmployeeMutation,
  useUpdateTempEmployeeMutation
} from "../../slices/admin/admin";
import { toast } from "react-toastify";

const AddTransportForm = ({ onClose, editData }) => {

  const [createTempEmployee, { isLoading: createLoading }] =
    useCreateTempEmployeeMutation();

  const [updateTempEmployee, { isLoading: updateLoading }] =
    useUpdateTempEmployeeMutation();

  const [formData, setFormData] = useState({
    userName: "",
    phone: "",
    userType: "",
    status: ""
  });

  const [errors, setErrors] = useState({});

  // Edit mode data load
  useEffect(() => {
    if (editData) {
      setFormData({
        userName: editData.name || "",
        phone: editData.phone || "",
        userType: editData.empDesignation || "",
        status: editData.isActive ? "true" : "false"
      });
    }
  }, [editData]);

  // Normal input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  // 🔥 Phone number change handler (STRICT)
  const handlePhoneChange = (e) => {
    let value = e.target.value;

    // Remove non-digits
    value = value.replace(/\D/g, "");

    // Prevent more than 10 digits
    if (value.length > 10) return;

    // Prevent first digit 1-5
    if (value.length === 1 && !/[6-9]/.test(value)) {
      return;
    }

    setFormData({ ...formData, phone: value });
    setErrors({ ...errors, phone: "" });
  };

  // 🔥 Prevent invalid paste
  const handlePhonePaste = (e) => {
    const pasted = e.clipboardData.getData("Text");
    const clean = pasted.replace(/\D/g, "");

    if (!/^[6-9][0-9]{9}$/.test(clean)) {
      e.preventDefault();
      toast.error("Invalid mobile number format");
    }
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.userName.trim()) {
      newErrors.userName = "User Name is required";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone Number is required";
    } else if (!/^[6-9][0-9]{9}$/.test(formData.phone)) {
      newErrors.phone =
        "Enter valid 10 digit mobile number (must start 6-9)";
    }

    if (!formData.userType) {
      newErrors.userType = "User Type is required";
    }

    if (!formData.status) {
      newErrors.status = "User Status is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    const payload = {
      name: formData.userName.trim(),
      phone: formData.phone,
      empDesignation: formData.userType,
      isActive: formData.status === "true"
    };

    try {
      if (editData) {
        await updateTempEmployee({
          id: editData._id,
          body: payload
        }).unwrap();

        toast.success("Temporary Employee updated successfully");
      } else {
        await createTempEmployee(payload).unwrap();

        toast.success("Temporary Employee created successfully");
      }

      onClose();

    } catch (error) {
      console.log("API Error:", error);

      const errorMessage =
        error?.data?.message ||
        error?.data?.error ||
        error?.error ||
        "Something went wrong";

      toast.error(errorMessage);
    }
  };

  return (
    <div className={styles.popupForm}>
      <div className={styles.header}>
        <h2 className={styles.tittle}>
          {editData ? "Edit User" : "Add User"}
        </h2>
        <span className={styles.closeIcons} onClick={onClose}>X</span>
      </div>

      <div className={styles.body}>

        {/* User Name */}
        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>User Name *</label>
          <input
            type="text"
            name="userName"
            placeholder="Enter User Name"
            value={formData.userName}
            onChange={handleChange}
            className={styles.input}
          />
          {errors.userName && (
            <p style={{ color: "red", fontSize: "13px" }}>
              {errors.userName}
            </p>
          )}
        </div>

        {/* Phone */}
        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>Phone Num *</label>
          <input
            type="text"
            name="phone"
            placeholder="Enter Phone Num"
            value={formData.phone}
            onChange={handlePhoneChange}
            onPaste={handlePhonePaste}
            maxLength={10}
            className={styles.input}
          />
          {errors.phone && (
            <p style={{ color: "red", fontSize: "13px" }}>
              {errors.phone}
            </p>
          )}
        </div>

        {/* User Type */}
        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>User Type *</label>
          <select
            name="userType"
            value={formData.userType}
            onChange={handleChange}
            className={styles.inputssss}
          >
            <option value="">Select Type</option>
            <option value="loadHandler">Load Handler</option>
            <option value="transportPerson">Transport Person</option>
          </select>
          {errors.userType && (
            <p style={{ color: "red", fontSize: "13px" }}>
              {errors.userType}
            </p>
          )}
        </div>

        {/* Status */}
        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>User Status *</label>
          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            className={styles.inputssss}
          >
            <option value="">Select Status</option>
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>
          {errors.status && (
            <p style={{ color: "red", fontSize: "13px" }}>
              {errors.status}
            </p>
          )}
        </div>

        {/* Buttons */}
        <div className={styles.footerButtons}>
          <button className={styles.cancel} onClick={onClose}>
            Cancel
          </button>

          <button
            className={styles.save}
            onClick={handleSubmit}
            disabled={createLoading || updateLoading}
          >
            {createLoading || updateLoading
              ? "Please wait..."
              : editData
              ? "Update"
              : "Add"}
          </button>
        </div>

      </div>
    </div>
  );
};

export default AddTransportForm;